import firstTimeUseDe from '../../public/locales/de/first_time_use.json'
import firstTimeUseEn from '../../public/locales/en/first_time_use.json'

import aiOperatorDe from '../../public/locales/de/ai_operator.json'
import automationsDe from '../../public/locales/de/automations.json'
import casesDe from '../../public/locales/de/cases.json'
import commonDe from '../../public/locales/de/common.json'
import dashboardDe from '../../public/locales/de/dashboard.json'
import devicesDe from '../../public/locales/de/devices.json'
import emergencyCallDe from '../../public/locales/de/emergency_call.json'
import facilitiesDe from '../../public/locales/de/facilities.json'
import floorsDe from '../../public/locales/de/floors.json'
import gatewaysDe from '../../public/locales/de/gateways.json'
import guardToursDe from '../../public/locales/de/guard_tours.json'
import incidentsDe from '../../public/locales/de/incidents.json'
import programRecommendationsDe from '../../public/locales/de/program_recommendations.json'
import quickReportDe from '../../public/locales/de/quick_report.json'
import settingsDe from '../../public/locales/de/settings.json'
import sopsDe from '../../public/locales/de/sops.json'
import tailgateDe from '../../public/locales/de/tailgate.json'
import videoWallDe from '../../public/locales/de/video_wall.json'
import aiOperatorEn from '../../public/locales/en/ai_operator.json'
import automationsEn from '../../public/locales/en/automations.json'
import casesEn from '../../public/locales/en/cases.json'
import commonEn from '../../public/locales/en/common.json'
import dashboardEn from '../../public/locales/en/dashboard.json'
import devicesEn from '../../public/locales/en/devices.json'
import emergencyCallEn from '../../public/locales/en/emergency_call.json'
import facilitiesEn from '../../public/locales/en/facilities.json'
import floorsEn from '../../public/locales/en/floors.json'
import gatewaysEn from '../../public/locales/en/gateways.json'
import guardToursEn from '../../public/locales/en/guard_tours.json'
import incidentsEn from '../../public/locales/en/incidents.json'
import programRecommendationsEn from '../../public/locales/en/program_recommendations.json'
import quickReportEn from '../../public/locales/en/quick_report.json'
import settingsEn from '../../public/locales/en/settings.json'
import sopsEn from '../../public/locales/en/sops.json'
import tailgateEn from '../../public/locales/en/tailgate.json'
import videoWallEn from '../../public/locales/en/video_wall.json'

/**
 * The single registration point for translation namespaces (ENG-33377).
 *
 * `i18n.ts`, `jest.setup.ts`, and `src/config/tests/i18n.test.ts` all read this object, so a
 * namespace added here is bundled by the app, available under Jest, and covered by the en/de
 * key-parity test at once. Keeping three hand-written copies of this list is how
 * `program_recommendations` ended up registered everywhere except `jest.setup.ts`.
 */
export const i18nResources = {
  en: {
    ai_operator: aiOperatorEn,
    automations: automationsEn,
    cases: casesEn,
    common: commonEn,
    dashboard: dashboardEn,
    devices: devicesEn,
    emergency_call: emergencyCallEn,
    facilities: facilitiesEn,
    first_time_use: firstTimeUseEn,
    floors: floorsEn,
    gateways: gatewaysEn,
    guard_tours: guardToursEn,
    incidents: incidentsEn,
    program_recommendations: programRecommendationsEn,
    quick_report: quickReportEn,
    settings: settingsEn,
    sops: sopsEn,
    tailgate: tailgateEn,
    video_wall: videoWallEn,
  },
  de: {
    ai_operator: aiOperatorDe,
    automations: automationsDe,
    cases: casesDe,
    common: commonDe,
    dashboard: dashboardDe,
    devices: devicesDe,
    emergency_call: emergencyCallDe,
    facilities: facilitiesDe,
    first_time_use: firstTimeUseDe,
    floors: floorsDe,
    gateways: gatewaysDe,
    guard_tours: guardToursDe,
    incidents: incidentsDe,
    program_recommendations: programRecommendationsDe,
    quick_report: quickReportDe,
    settings: settingsDe,
    sops: sopsDe,
    tailgate: tailgateDe,
    video_wall: videoWallDe,
  },
}
